export const validateFile = async (file: File): Promise<string | null> => {
  // ❌ No file
  if (!file) {
    return "No file selected";
  }

  // ❌ Wrong type (fallback safety)
  if (!file.name.toLowerCase().endsWith(".csv")) {
    return "Only CSV file is supported";
  }

  // ❌ Empty file
  if (file.size === 0) {
    return "File is empty. Please upload a valid CSV.";
  }

  // ❌ Too large (optional but recommended)
  if (file.size > 5 * 1024 * 1024) {
    return "File must be less than 5MB";
  }

  // ❌ Content validation
  try {
    const text = await file.text();

    const rows = text
      .split(/\r?\n/)
      .map(row => row.trim())
      .filter(row => row.length > 0);

    if (rows.length <= 1) {
      return "CSV has no data rows";
    }
  } catch {
    return "Unable to read file";
  }

  return null; // ✅ valid
};
